import {HTMLReactParserOptions, Element as ParserElement} from 'html-react-parser';
import {useTranslation} from 'react-i18next';

import {ClientDynamicContent, NodeElement} from 'components';
import {
    DynamicComponentNames,
    FeedbackSubmittedUnits as Units,
    FEEDBACK_SUBMITTED_DEFAULT_TEMPLATE
} from 'constants/client';
import {TRANSLATION_KEYS} from 'locale/translation-keys';
import {dynamicContentUtils} from 'utils/dynamic-content';
import './styles.scss';

const T_KEYS = TRANSLATION_KEYS.CLIENT_IN_SESSION_PAGE.IN_SESSION_WEB.SESSION_ENDED_VIEW;

const {isMatchElement, renderDefaultNode} = dynamicContentUtils;
const getOptions = (props: any): HTMLReactParserOptions => {
    const {title, description, localParticipant} = props;
    return {
        replace: (domNode: any) => {
            if (!domNode.attribs) {
                return null;
            }

            const node = domNode as ParserElement;

            if (isMatchElement(Units.Title, node)) {
                return <NodeElement node={node}>{title}</NodeElement>;
            }
            if (isMatchElement(Units.Description, node)) {
                return <NodeElement node={node}>{description}</NodeElement>;
            }
            if (isMatchElement(Units.Icon, node)) {
                return <NodeElement node={node}><div className='icon' /></NodeElement>;
            }
            return renderDefaultNode(node, {role: localParticipant.role});
        }
    };
};

export const FeedbackSubmitted: React.FC = () => {
    const {t} = useTranslation();

    return (
        <ClientDynamicContent
            component={DynamicComponentNames.FeedbackSubmitted}
            defaultTemplate={FEEDBACK_SUBMITTED_DEFAULT_TEMPLATE}
            optionsProps={{
                title: t(T_KEYS.FEEDBACK.TITLE),
                description: t(T_KEYS.FEEDBACK.DESCRIPTION)
            }}
            optionsGetter={getOptions}
        />
    );
};